<template>
  <div class="section-main__warp">
    <div class="standard-factor">
      <div class="left">
        <div class="title">减排策略库</div>
        <div class="content">
          <el-table ref="menuTable" :show-header="false" :data="menuData" highlight-current-row
            @row-click="handleRowClick">
            <el-table-column prop="name"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="right">
        <grasslands v-if="firstMenu"></grasslands>
        <cleanEnergy v-else></cleanEnergy>
      </div>
    </div>
  </div>
</template>

<script>
import grasslands from './grasslands.vue'
import cleanEnergy from './cleanEnergy.vue'
export default {
  components: {
    grasslands,
    cleanEnergy
  },
  data() {
    return {
      menuData: [],
      firstMenu: true
    }
  },
  mounted() {
    this.getMenuData()
  },
  methods: {
    getMenuData() {
      this.menuData = [{ 'id': '1', 'name': '草地和湿地' }, { 'id': '2', 'name': '清洁能源放电' }]
      this.$refs.menuTable.setCurrentRow(this.menuData[0]);
      this.firstMenu = true
    },
    handleRowClick(row) {
      if (row.id === '1') {
        this.firstMenu = true
      } else if (row.id === '2') {
        this.firstMenu = false
      }
    }
  }
}
</script>

<style>
.standard-factor .el-table__body td.el-table__cell {
  cursor: pointer;
}

.standard-factor .el-table__body tr.current-row>td.el-table__cell {
  background-color: rgb(215, 232, 255);
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.standard-factor {
  width: 100%;
  height: 100%;
  display: flex;

  .left {
    width: 300px;
    background-color: #ffffff;

    .title {
      margin: 16px 0 16px 16px;
      border-left: 5px solid #407aee;
      padding-left: 10px;
      font-size: 16px;
    }

    .content {
      padding: 20px 10px 20px 20px;
    }
  }

  .right {
    flex: 1;
    margin-right: -16px;
  }
}
</style>